<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveTestimonial()" autocomplete="off">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Informações do Depoimento</h4>

              <!-- Upload de Foto -->
              <div class="row mb-4">
                <div class="col-md-12">
                  <label class="d-block mb-2">Foto da Pessoa <span class="text-danger">*</span></label>
                  <input
                    ref="photo"
                    type="file"
                    name="photo"
                    accept="image/*"
                    @change="setImage"
                    style="display: none;"
                  />
                  <div class="text-center p-3 border rounded" style="background: #f8f9fa; max-width: 250px;">
                    <img
                      :src="testimonial.photo || require('@/assets/images/users/avatar-1.jpg')"
                      class="rounded-circle mb-2"
                      style="width: 100px; height: 100px; object-fit: cover; border: 2px solid #dee2e6;"
                    >
                    <div>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="$refs.photo.click()"
                      >
                        <i class="mdi mdi-camera"></i> Escolher Foto
                      </button>
                    </div>
                    <small class="text-muted d-block mt-2">Tamanho máximo: 2MB</small>
                  </div>
                </div>
              </div>

              <!-- Informações -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Nome <span class="text-danger">*</span></label>
                    <input
                      id="name"
                      v-model="testimonial.name"
                      name="name"
                      type="text"
                      class="form-control"
                      placeholder="Ex: João Silva"
                      :class="{
                        'is-invalid': submitted && $v.testimonial.name.$error,
                      }"
                    />
                    <div
                      v-if="submitted && !$v.testimonial.name.required"
                      class="invalid-feedback"
                    >
                      O nome é obrigatório.
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="position">Cargo/Empresa <span class="text-danger">*</span></label>
                    <input
                      id="position"
                      v-model="testimonial.position"
                      name="position"
                      type="text"
                      class="form-control"
                      placeholder="Ex: CEO na Empresa XYZ"
                      :class="{
                        'is-invalid': submitted && $v.testimonial.position.$error,
                      }"
                    />
                    <div
                      v-if="submitted && !$v.testimonial.position.required"
                      class="invalid-feedback"
                    >
                      O cargo/empresa é obrigatório.
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="testimonial">Depoimento <span class="text-danger">*</span></label>
                    <textarea
                      id="testimonial"
                      v-model="testimonial.testimonial"
                      name="testimonial"
                      rows="5"
                      class="form-control"
                      placeholder="Digite o texto do depoimento..."
                      :class="{
                        'is-invalid': submitted && $v.testimonial.testimonial.$error,
                      }"
                    ></textarea>
                    <div
                      v-if="submitted && !$v.testimonial.testimonial.required"
                      class="invalid-feedback"
                    >
                      O depoimento é obrigatório.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="float-right">
                <button type="button" @click="cancelar()" class="btn btn-dark mr-4">
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary mr-1">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'Testimonial',
  page: {
    title: 'Depoimento',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      testimonial: {
        id: '',
        name: '',
        position: '',
        photo: '',
        testimonial: '',
        binaryPhoto: null
      },
      submitted: false,
      title: 'Novo Depoimento',
      items: [
        {
          text: 'Depoimentos',
          href: '/testimonials'
        },
        {
          text: 'Novo Depoimento',
          active: true
        }
      ]
    }
  },
  validations: {
    testimonial: {
      name: { required },
      position: { required },
      testimonial: { required }
    }
  },
  mounted () {
    this.loadItem()
  },
  computed: {
    ...mapState('testimonials', { data: 'testimonial' })
  },
  methods: {
    ...mapActions('testimonials', {
      fetch: 'GetTestimonial',
      postData: 'SaveTestimonial'
    }),
    cancelar () {
      this.$router.push({ name: 'site-testimonials' })
    },
    setImage (e) {
      const file = e.target.files[0]
      if (!file) return

      if (file.type.indexOf('image/') === -1) {
        errorMessage('Alerta: Por favor selecione uma imagem.')
        return
      }

      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        errorMessage('Alerta: Tamanho máximo 2MB!')
        return
      }

      this.testimonial.binaryPhoto = file

      const reader = new FileReader()
      reader.onload = (event) => {
        this.testimonial.photo = event.target.result
      }
      reader.readAsDataURL(file)
    },
    loadItem () {
      if (this.$route.params.id !== undefined) {
        let loader = this.$loading.show()
        this.items[1].text = 'Editar Depoimento'
        this.title = 'Editar Depoimento'
        this.fetch(this.$route.params.id)
          .then(() => {
            this.testimonial = Object.assign({}, this.data)
          }).then(() => {
            loader.hide()
          })
      }
    },
    async saveTestimonial () {
      this.submitted = true
      this.$v.testimonial.$touch()
      if (this.$v.testimonial.$invalid) {
        window.scroll(0, 0)
        return
      }

      let loader = this.$loading.show()
      window.scroll(0, 0)

      const formData = new FormData()
      formData.append('id', this.testimonial.id || '')
      formData.append('name', this.testimonial.name)
      formData.append('position', this.testimonial.position)
      formData.append('testimonial', this.testimonial.testimonial)

      if (this.testimonial.binaryPhoto) {
        formData.append('photo', this.testimonial.binaryPhoto, 'photo.jpg')
      }

      await this.postData(formData).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.cancelar()
        loader.hide()
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        loader.hide()
      })
    }
  }
}
</script>
